module.exports = __webpack_public_path__ + "static/img/14.3b60678.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/14.png
// module id = ef9L
// module chunks = 0